import { createWebHistory, createRouter } from "vue-router";

import HomePage from "../pages/Home/HomePage.vue";
import DashboardPage from "../pages/Dashboard/DashboardPage.vue";
import PerformancePage from "../pages/Performance/PerformancePage.vue";
import RecordingsPage from "../pages/Recordings/RecordingsPage.vue";
import RealtimePage from "../pages/Realtime/RealtimePage.vue";
import ListOperationsPage from "../pages/Configurations/ListOperationsPage.vue";
import OperationPage from "../pages/Configurations/OperationPage.vue";
import PaymentPage from "../pages/Payment/PaymentPage.vue";
import DocumentationPage from "../pages/Documentation/DocumentationPage.vue";
import LoginPage from "../pages/Authentication/LoginPage.vue";
import RegisterPage from "../pages/Authentication/RegisterPage.vue";
import ForgotPasswordPage from "../pages/Authentication/ForgotPasswordPage.vue";
import ForgotPasswordSendEmailPage from "../pages/Authentication/ForgotPasswordSendEmailPage.vue";
import TermsPage from "../pages/TermsPage.vue";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage.vue";
import ErrorPage from "../pages/ErrorPage.vue";
import UsersPage from "../pages/Users/UsersPage.vue";
import EventRegistrationPage from "../pages/Events/EventRegistrationPage.vue";
import EventRegistrationsDashboardPage from "../pages/Events/EventRegistrationsDashboardPage.vue";

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/dashboard",
    name: "DashboardPage",
    component: DashboardPage,
  },
  {
    path: "/performance",
    name: "PerformancePage",
    component: PerformancePage,
  },
  {
    path: "/recordings",
    name: "RecordingsPage",
    component: RecordingsPage,
  },
  {
    path: "/realtime",
    name: "RealtimePage",
    component: RealtimePage,
  },
  {
    path: "/operations",
    name: "ListOperationsPage",
    component: ListOperationsPage,
  },
  {
    path: "/operation/:id",
    name: "OperationPage",
    component: OperationPage,
  },
  {
    path: "/payment",
    name: "PaymentPage",
    component: PaymentPage,
  },
  {
    path: "/documentation",
    name: "DocumentationPage",
    component: DocumentationPage,
  },
  {
    path: "/users",
    name: "UsersPage",
    component: UsersPage,
  },
  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/register",
    name: "RegisterPage",
    component: RegisterPage,
  },
  {
    path: "/forgot-password",
    name: "ForgotPasswordPage",
    component: ForgotPasswordPage,
  },
  {
    path: "/send-email-forgot-password",
    name: "ForgotPasswordSendEmailPage",
    component: ForgotPasswordSendEmailPage,
  },
  {
    path: "/terms",
    name: "TermsPage",
    component: TermsPage,
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicyPage",
    component: PrivacyPolicyPage,
  },
  {
    path: "/eventos/inscricoes",
    name: "EventRegistrationsDashboardPage",
    component: EventRegistrationsDashboardPage,
  },
  {
    path: "/eventos",
    name: "CurrentEventPage",
    component: EventRegistrationPage,
    meta: { public: true },
  },
  {
    path: "/eventos/:slug",
    name: "EventRegistrationPage",
    component: EventRegistrationPage,
    meta: { public: true },
  },
  {
    path: "/conexao-empresarial",
    redirect: "/eventos/conexao-empresarial",
    meta: { public: true },
  },
  {
    path: "/walt-inscricoes",
    redirect: "/eventos/inscricoes",
  },
  {
    path: "/:pathMatch(.*)*",
    name: "ErrorPage",
    component: ErrorPage
  }
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes: routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

export default router;
